import { render, staticRenderFns } from "./modifyStaff.vue?vue&type=template&id=7f623108&"
import script from "./modifyStaff.vue?vue&type=script&lang=js&"
export * from "./modifyStaff.vue?vue&type=script&lang=js&"
import style0 from "./modifyStaff.vue?vue&type=style&index=0&id=7f623108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports